'use strict';
(function() {
    angular.module('voyageReport')
        .component('voyageReportComponent', {
            templateUrl: 'voyage-report/components/voyage-report-component.html',
            controller: function($timeout, $scope, $stateParams, $window, $interval, EventManagerService, MessageService, PopupManager, CommonMasterData, voyageReportService, crewScheduleService) {

            	var vm = this;
                vm.model = {
                    view: 'VOYAGE',
                    showSearchArea: true,
                    airports: [],
                    crewTypes: [],
                    crewDetails: [],
                    voyageReports: [],
                    allVoyageReports: [],
                    distributionList: [],
                    masterLists: [],
                    keywordFilter : null,
                    redirectDepartments: []
                };
                vm.searchParams = {
                    fromDate: '',
                    toDate: '',
                    crewTypeCode: '',
                    crewName: null,
                    crewId: null,
                    origin: null,
                    destination: null,
                    keywordFilter: null,
                    subject : null,
                    crewComment : null,

                };

                vm.filtersList = {
                		isShowAll : true,
                		isShowOpened : false,
                		isShowClosed : false
                };

                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VOYAGE.ALL, showAllVoyageReports);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VOYAGE.OPENED, showOpenedVoyageReports);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VOYAGE.CLOSED, showClosedVoyageReports);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VOYAGE.MODEL_CLOSED, reloadVoyageReports);

                function loadResponsiveStyles() {
                    var height = 70 + 40 + angular.element('div.profile-tab-header').height();
                    angular.element(".search_panel_new").css("top", height);
                    height = 70 + angular.element('div.profile-tab-header').height() + angular.element(angular.element('.toolbar-color')[1]).height();
                    vm.model.masterLists.windowHeight = $window.innerHeight - height;
                    vm.model.masterLists.toolbarHeight = angular.element(angular.element('.toolbar-color')[1]).height();
                    vm.model.masterLists.outerDivWidth = $window.innerWidth - 75;

                    if (vm.model.masterLists.outerDivWidth > 1000){
                    	vm.model.masterLists.innerDivWidth = vm.model.masterLists.outerDivWidth;
                    }
                    else {
                    	vm.model.masterLists.innerDivWidth = vm.model.masterLists.outerDivWidth + 70;
                    }
                }

                vm.onChangeCrewType = function(crewType) {
                    loadCrewListByType(crewType);
                }

                function loadCrewListByType(crewType) {
                    var load = function() {
                        var param = {};
                        param.crewType = crewType;
                        param.active = true;
                        param.crewBase = '';
                        param.fleetExperince = '';

                        CommonMasterData.loadCrewList(param, function(response) {
                            vm.model.crewDetails = crewScheduleService.adaptCrewList(response);
                        }, function() {
                            console.log('Crew list retrieval error');
                        });
                    };
                    load();
                }

                vm.onSearchVoyageReport = function(param,isNewSearch) {
                    vm.searchParams = param;
                    vm.model.voyageReports = [];
                    vm.model.allVoyageReports = [];
                    removeClassTofilters();

                    voyageReportService.searchVoyageReport(param, function(response) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                        loadResponsiveStyles();
                        vm.model.voyageReports = response.voyageList;
                        vm.model.allVoyageReports = response.voyageList;
                        vm.model.showSearchArea = false;
                        vm.model.masterLists.keywordFilter = (!!param && !!param.keywordFilter) ? param.keywordFilter : getCachedKeywordFilter();
                        if(!!isNewSearch){
                        	showAllVoyageReports();
                        }
                        else{
                        	setSelectedFilter();
                        }

                        $timeout(function(d) {
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                        }, 500)

                    }, function(error) {
                        showHideLoading(false);
                        MessageService.error(error.msg[0]);
                    });
                }

                function getCachedKeywordFilter(){
                	return voyageReportService.getCachedKeywordFilter();
                }

                function setSelectedFilter(){
                	if(!!vm.filtersList.isShowAll){
                		showAllVoyageReports();
                	}
                	else if(!!vm.filtersList.isShowOpened){
                		showOpenedVoyageReports();
                	}
                	else if(!!vm.filtersList.isShowClosed){
                		showClosedVoyageReports();
                	}
                }

                vm.clickOnRow = function(selectedRow, flag) {
                	vm.model.showSearchArea = false;

                  // Create promises for the asynchronous calls
                  var loadDistributionListPromise = new Promise(function(resolve, reject) {
                    voyageReportService.loadDistributionList(function(response) {
                      vm.model.distributionList = response.distributionList;
                      resolve();
                    }, function(error) {
                      MessageService.error(error.msg[0]);
                      reject();
                    });
                  });

                  var loadDepartmentsListPromise = new Promise(function(resolve, reject) {
                    voyageReportService.loadDepartmentsList(function(response) {
                      vm.model.redirectDepartments = response.distributionList;
                      resolve();
                    }, function(error) {
                      MessageService.error(error.msg[0]);
                      reject();
                    });
                  });

                  // Wait for both promises to complete
                  Promise.all([loadDistributionListPromise, loadDepartmentsListPromise]).then(function() {
                    // Filter the distribution list
                    var filteredDistributionList = [];
                    vm.model.distributionList.forEach(function(dist) {
                      if (dist.isAdditionalDept == null || dist.isAdditionalDept !== true) {
                        filteredDistributionList.push(dist);
                      }
                    });
                    vm.model.distributionList = filteredDistributionList;

                    // Process informed departments
                    if (selectedRow.informedDepartments != null) {
                      var additionalDistributionList = selectedRow.informedDepartments.split(",");
                      var index = vm.model.distributionList.length;
                      additionalDistributionList.forEach(function(dept) {
                        var distributionItem = {};
                        distributionItem.distributionName = dept;
                        distributionItem.distributionId = index + 1;
                        distributionItem.isAdditionalDept = true;
                        vm.model.distributionList.push(distributionItem);
                        index = index + 1;
                      });
                    }

                    // Prepare details object
                    var details = {
                      "selectedRow": selectedRow,
                      "DistributionList": vm.model.distributionList,
                      "keywordFilter": vm.model.masterLists.keywordFilter,
                      "redirectDepartments": vm.model.redirectDepartments
                    };

                    // Handle flag actions
                    if (flag == "EDIT") {
                      PopupManager.openModal('EDIT_VOYAGE_REPORT_DETAILS', details);
                    } else if (flag == "OPEN") {
                      openSelectedVoyageReport(details.selectedRow);
                    } else {
                      deleteSelectedRow(details.selectedRow);
                    }
                  }).catch(function(error) {
                    console.error("Error loading data:", error);
                  });
                }

                function deleteSelectedRow(details) {
                    details.title = 'Confirmation';
                    details.messages = ["Are you sure to close this entry?"];
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmDailogue);

                    function confirmDailogue(pass) {
                        if (pass == 'YES') {
                            var param = {
                                "voyageReportId": details.voyageReportId,
                                "version": details.version
                            }
                            voyageReportService.closeVoyageEntry(param, function(response) {
                                vm.model.voyageReports[details.rowIndex].isClosed = 'Y';
                                MessageService.success("Closed successfully");
                                reloadVoyageReports(true);
                            }, function(error) {
                                MessageService.error(error);
                            });
                        }
                    }
                }

              function openSelectedVoyageReport(details) {
                details.title = 'Confirmation';
                details.messages = ["Are you sure you want to open this entry again?"];
                PopupManager.openModal('CONFIRM_DIALOG', details, confirmDailogue);

                function confirmDailogue(pass) {
                  if (pass == 'YES') {
                    var param = {
                      "voyageReportId": details.voyageReportId,
                      "version": details.version
                    }
                    voyageReportService.openVoyageEntry(param, function(response) {
                      vm.model.voyageReports[details.rowIndex].isClosed = 'N';
                      MessageService.success("Reopened the Voyage Report successfully");
                      reloadVoyageReports(true);
                    }, function(error) {
                      MessageService.error(error);
                    });
                  }
                }
              }

                function showAllVoyageReports() {
                	EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                    removeClassTofilters();
                    vm.model.voyageReports = angular.copy(vm.model.allVoyageReports);

                    vm.filtersList = {
                    		isShowAll : true,
                    		isShowOpened : false,
                    		isShowClosed : false
                    };

                    var elem = angular.element( document.querySelector('#allVoyage'));
                    elem.addClass('selected-filter-border');

                    $timeout(function(d) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    }, 500)
                }

                function showOpenedVoyageReports() {
                	EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                    vm.model.voyageReports = [];
                    removeClassTofilters();
                    vm.model.allVoyageReports.forEach(function(report) {
                        if (report.isClosed == 'N') {
                            vm.model.voyageReports.push(report);
                        }
                    });

                    vm.filtersList = {
                    		isShowAll : false,
                    		isShowOpened : true,
                    		isShowClosed : false
                    };

                    var elem = angular.element( document.querySelector('#openedVoyage'));
                    elem.addClass('selected-filter-border');

                    $timeout(function(d) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    }, 500)
                }

                function showClosedVoyageReports() {
                	EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                    vm.model.voyageReports = [];
                    removeClassTofilters();
                    vm.model.allVoyageReports.forEach(function(report) {
                        if (report.isClosed == 'Y') {
                            vm.model.voyageReports.push(report);
                        }
                    });

                    vm.filtersList = {
                    		isShowAll : false,
                    		isShowOpened : false,
                    		isShowClosed : true
                    };

                    var elem = angular.element( document.querySelector('#closedVoyage'));
                    elem.addClass('selected-filter-border');

                    $timeout(function(d) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    }, 500)
                }

                function reloadVoyageReports(flag) {
            		vm.onSearchVoyageReport(vm.searchParam);
                }

                function removeClassTofilters() {
                	vm.model.showSearchArea = false;
                    angular.element(".fixed_header_table_inner_div").scrollTop(0);

                    var elem = angular.element( document.querySelector('#allVoyage'));
                    elem.removeClass("selected-filter-border");

                    elem = angular.element( document.querySelector('#openedVoyage'));
                    elem.removeClass("selected-filter-border");

                    elem = angular.element( document.querySelector('#closedVoyage'));
                    elem.removeClass("selected-filter-border");
                }

                angular.element($window).bind('resize', function() {
                        $timeout(function() {
                            loadResponsiveStyles();
                        }, 0);
                    });

                function showHideLoading(isLoadingVisible) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                            flag: isLoadingVisible,
                            target: 'voyageReport',
                            animationName: 'crewing-loader'
                        });
                    }
                    (function() {
                        // load airports
                        CommonMasterData.getAirportList(function(airports) {
                            vm.model.airports = airports;
                        }, function() {
                            console.log('airports retrieval error');
                        });
                        // load crew types
                        CommonMasterData.getCrewTypeList(function(crewTypes) {
                            vm.model.crewTypes = crewTypes;
                        }, function() {
                            console.log('Crew type retrieval error');
                        });
                        // load distributionList
                        voyageReportService.loadDistributionList(function(response) {
                            vm.model.distributionList = response.distributionList;
                        }, function(error) {
                            MessageService.error(error.msg[0]);
                        });
                        loadResponsiveStyles();
                    })();
            },
            bindings: {}
        });
})();
